import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Phone16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_409)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.77625 1.32167L5.77719 1.32401L7.1905 4.87951C7.3574 5.29936 7.25849 5.80399 6.94536 6.12972L6.93974 6.13556L5.71362 7.38364C5.86109 8.17229 6.26674 8.88598 6.85231 9.4314C7.34759 9.98637 8.02347 10.3627 8.76243 10.4677C9.17651 10.0554 9.59215 9.64472 10.0016 9.22784C10.33 8.9121 10.8341 8.80608 11.2595 8.97521L14.8174 10.3895C15.4291 10.635 15.7135 11.3747 15.4489 11.9715C14.7094 13.4813 13.4184 14.6827 11.8544 15.3027C9.0048 16.4324 5.56947 14.5712 3.60204 12.5612C1.57121 10.4865 -0.0841573 7.31956 0.844905 4.3712C1.40356 2.77885 2.69302 1.43147 4.19316 0.690605C4.79298 0.424674 5.52929 0.70642 5.77625 1.32167ZM4.51817 2.21746L5.7188 5.23791L4.14085 6.84421C4.27144 8.23133 4.74464 9.50505 5.77949 10.4819C6.60269 11.3904 7.78897 11.9454 9.01442 11.9949C9.76867 12.0253 10.4153 10.9431 10.9047 10.4484L13.9229 11.6481C13.3341 12.6644 12.4208 13.4585 11.3249 13.899C8.94341 14.6488 6.30198 13.1752 4.67398 11.512C3.04718 9.85001 1.52903 7.24079 2.26844 4.84484C2.70303 3.73812 3.49728 2.81386 4.51817 2.21746Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_409'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Phone16.displayName = 'Phone16';
export default Phone16;
